import React, { useState, useRef, useEffect } from 'react';
import {
  IonButtons,
  IonButton,
  IonModal,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
  IonPage,
  IonList,
  IonItem,
  IonLabel,
  IonAvatar,
  IonImg,
  IonSearchbar,
  IonSelect,
  IonSelectOption,
  IonRow,
  IonCol,
  IonGrid,
  IonInput,
  IonFooter,
  IonIcon, 
  IonRange
} from '@ionic/react';
import { globeOutline, heartOutline, locationOutline, navigateOutline, phonePortraitOutline } from "ionicons/icons";

import { locations } from '../data';

export const RSBuyFilter = ({onDismiss, apply, prevFilter, map, priceCeiling}) => {

	const [inputs, setInputs] = useState({});

	const handleChange = (event) => {
		const name = event.target.name;
		const value = event.target.value;
		setInputs(values => ({...values, [name]: value}));
	}

	let prevFilterData = JSON.parse(prevFilter);

	const reSearchPrevFilter = async(i) => {

		if(prevFilterData[i].location && prevFilterData[i].location !== '') {
			prevFilterData[i].state = prevFilterData[i].location;
		}
		if(prevFilterData[i].search && prevFilterData[i].search !== '') {
			prevFilterData[i].q = prevFilterData[i].search;
		}

		apply(prevFilterData[i]);

	}

	const [priceMin, setPriceMin] = useState(priceCeiling - (priceCeiling/2));

	const [priceMax, setPriceMax] = useState(priceCeiling);

	function priceKnobChange(event){

		setPriceMin(event.detail.value.lower);

		setPriceMax(event.detail.value.upper);

		handleChange(
			{
				target: {
					name: 'max_price',
					value: event.detail.value.upper
				}
			}
		);

		handleChange(
			{
				target: {
					name: 'min_price',
					value: event.detail.value.lower
				}
			}
		);
	}

	const [location, setLocation] = useState('');

	let [locationResults, setLocationResults] = useState([]);
	
	const handleLocationInput = (ev) => {
		setLocationResults([]);
		let query = '';
		const target = ev.target;
		if (target) query = target.value.toLowerCase();
		
		if(!query) return;
		
		const matches = Object.entries(locations)
			.filter(([dzongkhag, gewogs]) => dzongkhag.toLowerCase().indexOf(query) > -1)
			.map(([dzongkhag]) => dzongkhag);

		setLocationResults(matches);

		if (matches.length === 1) {
			locationListClick(ev, matches[0]);
		} else if (matches.length > 1) {
			setLocation(target.value);
		} else {
			setLocation('');
		}
	};
	
	const locationListClick = (ev, gew) => {
		setLocation(gew);
		handleChange(
			{
				target: {
					name: 'state',
					value: gew
				}
			}
		);
		setLocationResults([]);
	};

	return (
		<IonPage>
		<IonHeader>
			<IonToolbar>
			<IonTitle>Filter</IonTitle>
			</IonToolbar>
		</IonHeader>
		<IonContent className="ion-padding">
			{prevFilterData && prevFilterData.length > 0 ?
				<span>
					<p>Recent Searches</p>
					{ prevFilterData.map((filter, index) => (
					<IonButton key={index} fill="outline" color="drukre" size="large" onClick={() => reSearchPrevFilter(index)}>
						<IonIcon icon={globeOutline}/> &nbsp;
						<IonLabel>
							<h3>{filter?.search}</h3>
							<p>{filter?.property_type}  {filter?.sale_type} {filter.location ? ' in ' + filter.location : ''}</p>
							<p>{filter.max_price ? 'Max Nu. '+filter.max_price : null}</p>
						</IonLabel>
					</IonButton>
					))}
				</span>
 			: null}
			
			<IonList>
			<IonItem>
				<IonSelect label="Property Type" interface="popover" placeholder="Select Property Type" okText="Choose Type" name="property_type" cancelText="Cancel Choice" onIonChange={handleChange}>
					<IonSelectOption value="HOUSE">House</IonSelectOption>
					<IonSelectOption value="LAND">Land</IonSelectOption>
					<IonSelectOption value="BUSINESS">Business</IonSelectOption>
				</IonSelect>
			</IonItem>
			</IonList>
			<IonSearchbar placeholder="Search For" name="q" onIonChange={handleChange}></IonSearchbar>
			<IonGrid>
				<IonRow>
					<IonCol size="4"><IonLabel>Price Range (Nu.)</IonLabel></IonCol>
					<IonCol>
						<IonRange
							aria-label="Price Range"
							dualKnobs={true}
							value={{
								lower: priceMin,
								upper: priceMax
							}}
							min={1000}
							max= {priceCeiling}
							onIonChange={(e) => priceKnobChange(e)}
						></IonRange>
					</IonCol>
				</IonRow>
				<IonRow>
					<IonCol size-md="4" size="12"></IonCol>
					<IonCol size-md="3" size="12" style={{textAlign: 'center'}}>
						Min: Nu. {priceMin}  - 
					</IonCol>
					<IonCol size="12" size-md="3" style={{textAlign: 'center'}}>
						Max: Nu. {priceMax}
					</IonCol>
				</IonRow>
			</IonGrid>
			<IonItem>
				<IonSearchbar onClearInput={(e) => setLocationResults([])} debounce={1000} label="Location" placeholder="Location" 
					value={location} name="location" onIonInput={(ev) =>handleLocationInput(ev)}
					onIonClear={() => {
						setLocation('');}}>
				</IonSearchbar>
			</IonItem>
			<IonList class="ion-margin-start">
				{Object.entries(locationResults).map(([dzo, gew]) => (
					<IonItem key={gew} onClick={(ev) => locationListClick(ev, gew)}>{gew}</IonItem>
				))}
			</IonList>
		</IonContent>
		<IonFooter>
			<IonRow>
				<IonCol>
					<div>
						<IonButton fill="outline" color="drukre" strong={true} onClick={() => onDismiss()}>Cancel</IonButton>
					</div>
				</IonCol>
				<IonCol>
					<div className="ion-float-end">
						<IonButton color="drukre" onClick={() => apply(inputs)}>Apply</IonButton>
					</div>
				</IonCol>
			</IonRow>
		</IonFooter>
		</IonPage>
	);
}